import React from 'react';

import { ia } from 'lib/helpers/utility';
import { useOrganizationLocations } from 'lib/hooks/queries/organization/useOrganizationLocations';

import DocumentsTable from '../../shared/DocumentsTable/DocumentsTable';

export default function PracticeDocuments() {
  const { data: locationData } = useOrganizationLocations({});
  const manyLocations = ia(locationData?.locations);

  const options = {
    enableDocumentEdit: true,
    enableDocumentMarkup: true,
    enableDocumentSharing: true,
    enableAppointmentLinking: false,
    showImportantDocuments: false,
    showSendPatientForms: true,
    showPatient: true,
    enablePatientSelect: true,
    enableCheckboxSelection: true,
    enableSendAsFax: true,
    enableTags: true,
    enableShareWithPractice: manyLocations
  };

  return (
    <div className="h-full">
      <DocumentsTable level="practice" options={options} />
    </div>
  );
}
